<!-- begin:: Page -->
<ng-container *ngIf="selfLayout !== 'blank'; else blankLayout">
  <!-- begin:: Header Mobile -->
  <header-mobile></header-mobile>
  <!-- end:: Header Mobile -->

  <div class="kt-grid kt-grid--hor kt-grid--root">
    <!-- begin::Body -->
    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">

      <!-- begin:: Aside Left -->
      <ng-container *ngIf="asideDisplay">
        <button class="kt-aside-close" id="kt_aside_close_btn"><i class="la la-close"></i></button>
        <aside-left></aside-left>
      </ng-container>
      <!-- end:: Aside Left -->

      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
        <!-- begin:: Header -->
        <header *ngIf="desktopHeaderDisplay"></header>
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content"
          [ngClass]="{'kt-content--fit-top': fitTop}">

          <!-- begin:: Content Head -->
          <subheader *ngIf="subheaderDisplay"></subheader>
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div ktContentAnimate class="kt-container kt-grid__item kt-grid__item--fluid"
            [ngClass]="{'kt-container--fluid': fluid}">
            <router-outlet></router-outlet>
            <!-- <app-dashboard>  should be here-->
          </div>
          <!-- end:: Content Body -->

        </div>

        <!-- end:: Content -->
        <footer></footer>
      </div>



    </div>
    <!-- end:: Body -->
    <quick-panel></quick-panel>
    <scroll-top></scroll-top>
  </div>

</ng-container>
<!-- end:: Page -->

<ng-template #blankLayout>
  <p>Blank Div</p>
  <router-outlet></router-outlet>
</ng-template>
